import gallery01 from '../asset/gallery01.jpg';
import gallery02 from '../asset/gallery02.jpg';
import gallery03 from '../asset/gallery03.jpg';
import gallery04 from '../asset/gallery04.jpg';
import gallery05 from '../asset/gallery05.jpg';
import gallery06 from '../asset/gallery06.jpg';
import gallery07 from '../asset/gallery07.jpg';
import photo01 from '../asset/photo01.jpg';
import Carousel from 'react-bootstrap/Carousel';

const data = [
  {
    imgUrl: gallery01,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  },  
  {
    imgUrl: gallery02,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  },    {
    imgUrl: gallery03,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  },    {
    imgUrl: gallery04,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  },    {
    imgUrl: gallery05,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  },    {
    imgUrl: gallery06,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  }, {
    imgUrl: gallery07,
    title: "Stable Diffusion 中文网",
    summary: "这些美轮美奂的图片，通过AI技术你也可以轻松制作出来……",
  },  
];

export default function Jumbotron() {
  return (
    <Carousel className="jumbotron">
      {data.map((d, idx) => (
      <Carousel.Item key={idx} style={{'textAlign': 'center', background: '#000'}}>
        <a href="#tutorial"><img
          width={1080}
          src={d.imgUrl}
          alt={d.title}
        /></a>
        <Carousel.Caption>
          <h3>{d.title}</h3>
          <p>{d.summary}</p>
        </Carousel.Caption>
      </Carousel.Item>
      ))}

    </Carousel>
  )
} 